import styled from "styled-components";

export const LogoResume = styled.img`
    display: block;
    margin: auto;
    margin-bottom: 30px;
    @media print{
        display: block;
    }
`

export const ResumeTitle = styled.h3`
    text-align: center;
    font-size: 30px;
    color: #056731;
    margin: 0;
`
export const ClientTitle = styled.strong`
    text-align: center;
    font-size: 20px;
    color: #666666;
    margin: 0;
    margin-bottom: 20px;
    display: block;
`
export const FinalPrice = styled.p`
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    color: #056731;
    width: 100%;
`
export const ContentButtons =  styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 500px;
    margin: auto;
`
export const LinkButton = styled.a`
    font-size: 14px;
    display: block;
    margin: auto;
    background-color: #056731;
    padding: 15px 40px;
    color: #ffffff;
    font-weight: 600;
    border: 0;
    border-radius: 5px;
    text-decoration: none;
`
export const PrintButton = styled.button`
    font-size: 14px;
    display: block;
    margin: auto;
    background-color: #056731;
    padding: 15px 40px;
    color: #ffffff;
    font-weight: 600;
    border: 0;
    border-radius: 5px;
    @media print{
        display: none;
    }
`
export const StyledCard = styled.div`
     width: 300px;
    min-height: 600px;
    border: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;
    padding: 15px;
    /* text-align: center; Removido ou ajustado para não forçar centralização em tudo */
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    position: relative;
    
    /* Nova regra para os itens com ícone e texto */
    .icon-text-item {
        display: flex;
        align-items: center; /* Mantém o alinhamento vertical */
        justify-content: flex-start; /* Alinha o conteúdo (imagem + texto) à esquerda */
        width: 100%; /* Garante que a div ocupe a largura para o alinhamento funcionar bem */
        margin-bottom: 12px; /* Espaço entre os itens */
    }
    
    .icon-text-item img {
        max-width: 20%; /* Ajuste conforme necessário, era 27% */
        margin-right: 10px; /* Espaço entre a imagem e o texto */
        /* Remove margens automáticas laterais para não centralizar */
        margin-top: 0; 
        margin-bottom: 0;
        margin-left: 0; 
    }
    
    .icon-text-item p {
        margin: 0; /* Remove margens padrão do parágrafo */
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 500;
        word-break: break-word;
        text-align: left; /* Garante que o texto dentro do parágrafo comece à esquerda */
        flex-grow: 1; /* Permite que o texto ocupe o espaço restante */
    }
    
    div {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    img {
        max-width: 27%;
        margin: 5px auto;
    }
    
    p {
        margin: 10px 0;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 500;
        word-break: break-word;
    }
    
    #potencia {
        font-size: 18px;
        font-weight: bold;
        text-transform: none !important;
        margin-bottom: 10px;
    }
    
    #valor-kit {
        font-size: 17px;
        font-weight: semi-bold;
        padding: 10px;
        border-radius: 10px;
        position: absolute;
        bottom: 55px; /* Ajustando para cima do botão */
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
    }
    
    button {
        font-size: 15px;
        background: transparent;
        padding: 5px 15px;
        border-radius: 10px;
        border: 0.5px solid;
        font-weight: bold;
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
    }
    
    @media screen and (max-width: 480px) {
        width: 100%;
        min-height: 600px;
    }
`;



export const StyledCardPage = styled.div`
    width: 300px;
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    text-align: center;
        
    div{
        display: flex;
        align-items: center;
    }
    img {
        max-width: 27%;
    }
    p {
        margin: 10px auto 10px auto;
        font-size: 14px;
    }
    #potencia {
        font-size: 17px;
        font-weight: bold;
        text-transform: unset !important;
    }
    #disponibilidade {
    }

    #valor-kit {
        font-size: 17px;
        font-weight: semi-bold;
    }
    button {
        font-size: 15px;
        background: transparent;
        padding: 0.2rem;
        border-radius: 10px;
        border: 0.5px solid;
        padding: 5px 15px;
        margin: 0px;
    } 
`
export const ContainerResume = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    @media print{
        display: block;
    }
    @media screen and (max-width: 480px){
        display: block;
        overflow-x: auto;
    }
`
export const ResumeCard = styled.div`
    max-width: 300px;
    padding: 0px 50px;
    margin-top: 50px;
    @media print{
        display: none;
    }
    div{
        display: flex;
        align-items: center;
    }
    img {
        max-width: 27%;
    }
    p {
        margin: 10px auto 10px auto;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 500;
        word-break: break-all;
    }
    #potencia {
        font-size: 17px;
        font-weight: bold;
        text-transform: unset !important;
    }
    #disponibilidade {
    }

    #valor-kit {
        font-size: 17px;
        font-weight: semi-bold;
    }
    button {
        font-size: 15px;
        background: transparent;
        padding: 0.2rem;
        border-radius: 10px;
        border: 0.5px solid;
        padding: 5px 15px;
        margin: 0px;
    } 
`

export const ResumeInformations = styled.div`
    background-color: #eeeeee;
    padding: 15px;
    border-radius: 10px;
    @media print{
        background-color: #eeeeee;
        border-radius: 5px;
    }
    table{
        width: 100%;
        thead{
            font-weight: 600;
            background-color: #464646;
            color: #ffffff;
        }
        tr,td{
            text-align: center;
            height: 35px;
        }
        tbody{
            tr{
                height: 50px;
                td{
                    padding: 0px 30px;
                    font-size: 14px;
                }
                :nth-child(odd){
                    background-color: #f9f9f9;
                }
                :nth-child(even){
                    background-color: #ffffff;
                }
            }
        }
    }
    @media print{
        table{
            width: 100%;
            thead{
                font-weight: 600;
                background-color: #464646;
                color: #ffffff;
            }
            tr,td{
                text-align: center;
                height: 35px;
            }
            tbody{
                tr{
                    height: 50px;
                    td{
                        padding: 0px 30px;
                        font-size: 14px;
                    }
                    :nth-child(odd){
                        background-color: #f9f9f9;
                    }
                    :nth-child(even){
                        background-color: #ffffff;
                    }
                }
            }
        }
    }
`
export const Informations = styled.div`
    display: block;
    max-width: 1000px;
    margin: auto;
    margin-top: 20px;
    position: absolute;
    left: -9999px;
    top: -9999px;
    padding: 50px;
    strong{
        display: block;
        text-transform: uppercase;
        margin-bottom: 10px;
    }
    & .condicoes{
        width: 50%;
        float: left;
        margin-bottom: 20px;
        p{
            font-size: 12px;
            margin: 0;
        }
    }
    & .pagamento{
        width: 40%;
        float: left;
        margin-bottom: 20px;
        margin-left: 10%;
        p{
            font-size: 12px;
            margin: 0;
        }
    }
    & .info{
        width: 100%;
        p{
            font-size: 12px;
            margin: 0;
        }
    }
`
export const CloseModal = styled.button`
    position: absolute;
    right: 30px;
    top: 30px;
    background-color: transparent;
    border: 0;
    color: #666666;
    cursor: pointer;
    @media print{
        display: none;
    }
`
export const ModalOverlay = styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    @media screen and (max-width: 480px){
        align-items: flex-start;
        overflow: auto;
    }
`
export const Modal = styled.div`
        position: relative;
        max-width: 1000px;
        background-color: white;
        padding: 50px;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    @media screen and (max-width: 480px){
        
    }
`